module.exports = __webpack_public_path__ + "assets/images/project/ang-mo-kio-ave1/01.jpg?v=f255ee36";